// ✅ US Market Mobile Responsive - Thin Wrapper (DRY principle)
import MobileResponsivePage from '../../sub/mobile-responsive';
import SEOHead from '../../../components/SEOHead';

export default function USMobileResponsive() {
  return (
    <>
      <SEOHead
        title='Mobile Responsive Design | LBVisible'
        description='Mobile-first responsive web design for all devices.'
        keywords='mobile responsive design, mobile websites, responsive web design USA'
        canonicalUrl='/us/sub/mobile-responsive'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/mobile-responsive' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/mobile-responsive' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/mobili-versija' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/mobile-responsive' },
        ]}
      />

      <MobileResponsivePage />
    </>
  );
}
